<template>
    <div id="vehicle_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Travel Form</div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content travel-form">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal form-custom-select basic-form-container" id="TravelRequestForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="full_name">Full Name (Legal name as shown on ID):</label>
                                        <input type="text" class="form-control" v-model="full_name" id="full_name" placeholder="Enter Full Name" name="full_name">
                                        <div class="field-error">{{full_name_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="birth_date">Birth Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="birth_date" name="birth_date" v-model="birth_date" :config="options"></date-picker>
                                            <label for="birth_date"  class="fp-calendar input-calender-icon"></label>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="reason_for_business_trip">Reason for Business Trip:</label>
                                        <input type="text" class="form-control" v-model="reason_for_business_trip" id="reason_for_business_trip" placeholder="Enter reason for business trip" name="reason_for_business_trip">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="facility_requesting_from">Facility Requesting From:</label>
                                        <input type="text" class="form-control" v-model="facility_requesting_from" id="facility_requesting_from" placeholder="Enter facility requesting from" name="facility_requesting_from">
                                    </div>
                                    
                                    <div class="col form-group">
                                        <label class="control-label require" for="department_name">Department:</label>
                                        <v-select v-model="department_name" name="department_name" placeholder="Select Department."
                                                label="text"
                                                :options="deptArr">
                                        </v-select>
                                        <div class="field-error">{{department_name_err_msg}}</div>
                                    </div>

                                    <div class="col form-group" id="filterDateRange">
                                        <label class="control-label" for="travel_date_time">Travel date(s) and time:</label>
                                        <v-md-date-range-picker id="travel_date_time" name="travel_date_time" onkeydown="return false" autocomplete="off" @change="handleChange($event)" show-year-select></v-md-date-range-picker>
                                    </div>
             
                                    <div class="col form-group">
                                        <label class="control-label" for="departure_from">Departure From:</label>
                                        <input type="text" class="form-control" v-model="departure_from" id="departure_from" placeholder="Enter departure from" name="departure_from">
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="destination">Destination:</label>
                                        <input type="text" class="form-control" v-model="destination" id="destination" placeholder="Enter destination" name="destination">
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="duration_of_stay">Duration of Stay:</label>
                                        <input type="text" class="form-control" v-model="duration_of_stay" id="duration_of_stay" placeholder="Enter duration of stay" name="duration_of_stay">
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="approved_by_which_manager">Approved by which Manager?:</label>
                                        <input type="text" class="form-control" v-model="approved_by_which_manager" id="approved_by_which_manager" placeholder="Enter approved by which manager name?" name="approved_by_which_manager">
                                        <div class="field-error">{{approved_by_which_manager_err_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="phone_no">Phone (Staying Person Info):</label>
                                        <input  type="text" v-model="phone_no" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" id="phone_no" name="phone_no" placeholder="999-999-9999" class="form-control">
                                        <!-- <input-mask id="phone_no" :alwaysShowMask="true" name="phone_no" v-model="phone_no" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                        <div class="field-error">{{phone_no_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="email_id">Email (Staying Person Info):</label>
                                        <input type="text" class="form-control" v-model="email_id" id="email_id" placeholder="Enter email address" name="email_id">
                                        <div class="field-error">{{email_id_err_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="comments">Comment Section / Accommodations:</label>
                                        <!--<input type="text" class="form-control" v-model="comments" id="comments" placeholder="Enter Comments" name="comments">-->
                                        <textarea class="form-control" v-model="comments" placeholder="Please Enter Comments / Accommodations" ref="textarea" id="comments" name="comments" rows="3"></textarea>
                                    </div>

                                </div>
                                
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="sendEmailBtn" class="btn btn-primary" v-on:click.prevent="SendTravelData" >
                                    <i class="fp-save"> </i>  Send Email
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer v-if="request_flag != 'load'"></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "TravelRequestForm",
  
  metaInfo() {
      return {
          title: "Travel Form | " +process.env.COPYRIGHT_NAME
      }
  },
  mixins:[commonMixins],
  data: () => ({
    isEdit:false,
    permissions: [],
    cantAccessPage: true,
    
    sitekey:"6Lf4Io4UAAAAAByVmOV4fn2P5RAqBEq8D8fBbqNb",
    full_name: "",
    birth_date: "",
    reason_for_business_trip: "",
    facility_requesting_from: "",
    department_name: null,
    travel_date_time: "",
    departure_from: "",
    destination: "",
    duration_of_stay: "",
    approved_by_which_manager: "",
    phone_no: "",
    email_id: "",
    comments: "",
    deptArr: [
        {
            value: "Corporate",
            text: "Corporate"
        },
        {
            value: "Lease",
            text: "Lease"
        },
        {
            value: "Rental",
            text: "Rental"
        },
        {
            value: "Service",
            text: "Service"
        },
        {
            value: "Other",
            text: "Other"
        }
    ],
    options: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    loading:false,

    full_name_err_msg: "",
    department_name_err_msg: "",
    approved_by_which_manager_err_msg: "",
    phone_no_err_msg: "",
    email_id_err_msg: "",
    captchaerror: "",
    googleResponse: "",
    request_flag: '',
    
  }),
  watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    self.cantAccessPage = true;
                }
            }
        },
  },

  created: function() {

  },

  mounted: function() {

        var self = this;

        var path = window.location.pathname;
        var flag = path.split("/");
        self.request_flag = flag[2];
        
        if(self.request_flag != 'load') {
            self.getPermissions();
        }
  },
  methods: {

    SendTravelData(flag) {
        var self = this;
        var error = false;

        self.full_name_err_msg = "";
        self.department_name_err_msg = "";
        self.approved_by_which_manager_err_msg = "";
        self.phone_no_err_msg = "";
        self.email_id_err_msg = "";

        if (!self.full_name || self.full_name == null || self.full_name == "") {
            self.full_name_err_msg = "Full Name Required.";
            error = true;
        }

        if (self.department_name == null || !self.department_name.value) {
            self.department_name_err_msg = "Pick Department Required.";
            error = true;
        }

        if (!self.approved_by_which_manager || self.approved_by_which_manager == null || self.approved_by_which_manager == "") {
            self.approved_by_which_manager_err_msg = "Approved by which manager name Required.";
            error = true;
        }

        if (self.phone_no.trim() == "___-___-____") {
            self.phone_no_err_msg = "Staying Person Phone Required.";
            error = true;
        }
        if (self.phone_no.trim() != "" && self.phone_no.trim() != "___-___-____") {
            var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
            if (!self.phone_no.trim().match(phoneRE)) {
                self.phone_no_err_msg = "Enter Valid Phone No.";
                error = true;
            }
        }
        if (!self.email_id || self.email_id == null || self.email_id == "") {
            self.email_id_err_msg = "Staying Person Email Required.";
            error = true;
        }
        if (self.email_id.includes(',')){
            var email_id = self.email_id.split(',');
            if (email_id.length > 0){
                for( var i=0;i < email_id.length;i++){
                    if (!self.validEmail(email_id[i])){
                        self.email_id_err_msg = 'Please enter valid email';
                        error = true;
                    }
                }
            }
        }else{
            if (self.email_id != '' && !self.validEmail(self.email_id)){
                self.email_id_err_msg = 'Please enter valid email';
                error = true;
            }
        }


        if (!error) {
            self.loading = true;
            
            if (flag == "Save and Continue") {

                $("#sendEmailBtn").prop("disabled", true);

            }else{

                $("#sendEmailBtn").val("Saving ...");
                $("#sendEmailBtn").prop("disabled", true);
            }

            var fields = $("#TravelRequestForm").serializeArray();
            fields.push({name: "department_name", value: self.department_name.value});
            var travel_date_time = $("#filterDateRange .text-field").val();
            fields.push({name: "travel_date_time", value: travel_date_time});
            
            $.ajax({
                url: process.env.ROOT_API + "/travelrequest/sendemail",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    
                    $("#sendEmailBtn").val("Send Email");
                    $("#sendEmailBtn").prop("disabled", false);

                    if (data.status == "success") {

                        $("#TravelRequestForm").trigger("reset");
                        self.full_name = "";
                        self.birth_date = "";
                        self.reason_for_business_trip = "";
                        self.facility_requesting_from = "";
                        self.department_name = "";
                        self.travel_date_time = "";
                        self.departure_from = "";
                        self.destination = "";
                        self.duration_of_stay = "";
                        self.approved_by_which_manager = "";
                        self.phone_no = "",
                        self.email_id = "",
                        self.comments = "";

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {

                    self.loading = false;

                    $("#sendEmailBtn").val("Send Email");
                    $("#sendEmailBtn").prop("disabled", false);

                    self.generateStatusCodeMessage(jqXHR, false, 'travel-form-sent')
                }
            });
        }else{
            self.errorValidationFocus();
        }
    },
    validEmail: function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    handleChange (values) {
        this.values = values;
        var selectedDateArr = [];
        for( var i=0; i<values.length; i++ ) {
            selectedDateArr[i] = values[i].format('MM/DD/YYYY');
        }
    },
    formatString(data) {
        var self = this;
        var value = data.replace(/_/g, " ");
        var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
            return letter.toUpperCase();
        });
        return upp;
    },
  }
};
</script>
<style scope>
#travel_date_time .activator-wrapper label{
    display: none;
}
#travel_date_time .activator-wrapper .text-field {
    display: block;
    width: 100%;
    height: calc(1.3em + 0.75rem + 2px);
    font-size: 0.9rem;
    padding: 0.375rem 0.75rem;
    border: 1px solid var(--border-color);
    border-radius: 0.25rem;
    margin: 0;
    background-color: var(--bg-color);
    color: var(--primary-font-color);
}
</style>



// WEBPACK FOOTER //
// src/components/TravelRequestForm.vue